<div
  style="
    color: white;
    background-color: #0a0a0a;
    border-radius: 6px;

    text-align: center;
    height: 400px;
    padding: 20px;
  "
>
  <div style="margin-top: 50px; margin-bottom: 20px">
    <h2 mat-dialog-title style="color: white; font-size: 48px">Coming Soon</h2>
    <mat-dialog-content style="color: white; font-size: 16px; line-height: 1.5"
      >We’re almost ready to ship. Get early access and help shape the <br />
      future of Angular tooling.</mat-dialog-content
    >
  </div>
  <div class="icon-wrapper">
    <mat-icon class="big-icon">construction</mat-icon>
  </div>

  <!-- 
  <mat-dialog-actions>
    <div style="display: flex; flex-direction: column">
      <input
        type="text"
        placeholder="Enter your email here"
        style="
          border-radius: 12px;
          background-color: #ffffff1a;
          height: 30px;
          width: 450px;
          font-size: 16px;
          padding: 12px 16px;
          margin-bottom: 30px;
        "
      />
      <button
        mat-raised-button
        matRipple
        style="
          height: 48px;
          border-radius: 6px;

          background: linear-gradient(to left, #dd0031e5, #c03050c2);
          color: white !important;
          font-size: 16px;
          line-height: 24px;
        "
      >
        Join Waitlist
      </button>
    </div></mat-dialog-actions
  > -->
</div>
